






















































































import Vue from 'vue';
import Component from 'vue-class-component';

import CanalIcon from '@/components/icons/CanalIcon.vue';

@Component({
  components: {
    CanalIcon,
  },
})
export default class OptiLegend extends Vue {
  activeKey = '';
  openTimeout = -1;
  closeTimeout = -1;

  toggle(open: boolean) {
    this.clearTimeouts();
    if (open) {
      this.open();
    } else {
      this.close();
    }
  }
  open() {
    this.activeKey = '1';
  }
  close() {
    this.closeTimeout = setTimeout(() => (this.activeKey = ''), 300);
  }
  clearTimeouts() {
    if (this.openTimeout !== -1) {
      clearTimeout(this.openTimeout);
    }
    if (this.closeTimeout !== -1) {
      clearTimeout(this.closeTimeout);
    }
  }
}
